import { Text } from '@chakra-ui/react/text';

const CustomTickX = ({ x, y, payload, tickFormatter, className, width, height, index }: any) => {
  if (payload.value === 0 || payload.value === 'auto') return null;
  return (
    <foreignObject x={x - 10} y={y} className={className} width={width} height={height}>
      <Text as="span" textStyle="body/md/regular" color="text/tertiary">
        {tickFormatter ? tickFormatter(payload.value, index) : payload.value}
      </Text>
    </foreignObject>
  );
};

export default CustomTickX;
